const PROGRESS_STEP = {
  FIND_LISTING: 'findListing',
  VERIFY_CONTACT: 'verifyContact',
};

const PROGRESS_STEP_CONFIG = [
  {
    key: PROGRESS_STEP.FIND_LISTING,
    label: 'Find listings',
  },
  {
    key: PROGRESS_STEP.VERIFY_CONTACT,
    label: 'Verify contact',
  },
];

const STEP = {
  FIND_LISTING_RESULTS: 'findListingResults',
  FIND_LISTING_SUCCESS: 'findListingSuccess',
  VERIFY_CONTACT_LIST: 'verifyContactList',
  VERIFY_CONTACT_SUCCESS: 'verifyContactSuccess',
} as const;

const DEEP_LINK_STEP: Record<string, string> = {
  [PROGRESS_STEP.FIND_LISTING]: STEP.FIND_LISTING_RESULTS,
  [STEP.VERIFY_CONTACT_LIST]: STEP.VERIFY_CONTACT_LIST,
};

export { PROGRESS_STEP, PROGRESS_STEP_CONFIG, DEEP_LINK_STEP, STEP };
